import { Form, Input, Select, Space, Switch } from 'antd';
import styles from '../../Dashboard/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { getAllClients } from 'pages/Tasks/redux/slice';
import { createProject, selectConfigureSlice } from '../redux/slice';
import { debounce } from 'lodash';

export default function CreateProjectModal({
  isOpen,
  setIsOpen,
  onAssign,
  data,
  name
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const isEdit = typeof isOpen === 'number';
  const [clients, setClients] = useState([]);
  const { loading } = useSelector(selectConfigureSlice);

  const handleGetAllClients = (search = '') => {
    const payload = { search };
    dispatch(getAllClients(payload)).then((res) => {
      if (res?.payload?.success) {
        setClients(res?.payload?.data);
      }
    });
  };

  //   on modal close
  const handleClose = () => {
    isEdit ? setIsOpen(null) : setIsOpen(false);
  };

  //after modal is closed
  const handleafterClose = () => {
    form.resetFields();
  };

  //init data
  useEffect(() => {
    handleGetAllClients();
    if (isEdit && data) {
      form.setFieldsValue({
        project: data.project,
        client_id: data.client_id,
        is_active: data.is_active
      });
    }
  }, [isEdit, isOpen]);

  const debouncedSearch = useCallback(
    debounce((value) => {
      handleGetAllClients(value);
    }, 300),
    []
  );

  //   on finish
  const onFinish = (values) => {
    const payload = {
      ...values
    };
    if (isEdit) {
      payload.id = isOpen;
    }
    dispatch(createProject(payload)).then((res) => {
      if (res?.payload?.success) {
        handleClose();
        onAssign();
      }
    });
  };

  return (
    <CustomModal
      visible={isOpen}
      footer={null}
      className={`!w-full sm:!w-[40%] md:!w-[35%] lg:!w-[30%] xl:!w-[25%] ${styles.customModal}`}
      closable={false}
      centered
      afterClose={handleafterClose}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
          {isEdit ? 'Edit' : 'Add'} {name}
        </h3>

        <div className={'!mt-4 flex flex-col gap-2'}>
          <FormItem
            label="Project"
            name="project"
            rules={[{ required: true, message: 'Project is required' }]}
            className={styles.customLable}
          >
            <Input placeholder="Enter name" />
          </FormItem>

          <FormItem
            label="Client"
            name="client_id"
            rules={[{ required: true, message: 'Client is required' }]}
            className={styles.customLable}
          >
            <Select
              showSearch
              optionFilterProp="children"
              defaultValue="Select client"
              style={{ width: '100%' }}
              className={styles.selectField}
              onSearch={debouncedSearch}
            >
              {clients?.length
                ? clients?.map((item, index) => {
                    return (
                      <option value={item?.id} key={index}>
                        {item?.client_name}
                      </option>
                    );
                  })
                : ''}
            </Select>
          </FormItem>

          {isEdit ? (
            <FormItem
              valuePropName="checked"
              name="is_active"
              label="Is active?"
              className={styles.customLable}
            >
              <Switch size="small" />
            </FormItem>
          ) : null}
        </div>
        <FormItem className="text-center">
          <Space style={{ marginTop: '20px' }}>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => handleClose()}
              type="primary"
              ghost
            >
              Cancel
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              type="primary"
              loading={loading}
            >
              {isEdit ? 'Update' : 'Add'} {name}
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </CustomModal>
  );
}
